import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Bitcoin_Icon.png")